import { useState } from "react";
import parent1 from "../Assests/Testimonials/Parent1.jpg";
import parent2 from "../Assests/Testimonials/parent2.jpeg";
import parent3 from "../Assests/Testimonials/Parent5.png";
import parent4 from "../Assests/Testimonials/Parent4.png";
import parent5 from "../Assests/Testimonials/SDS_0001.JPG";

const reviews = [
//   {
//     name: "Ravindra Patel",
//     link: "https://www.google.com/maps/contrib/112225771967186138228/reviews?hl=en-IN",
//     rating: 5,
//     time: "8 months ago",
//     text: "Seekers Bay Pre-School is a wonderful place for kids to learn and grow. The teachers are caring, patient, and always supportive. The activities are creative and engaging, helping children build confidence and skills in a fun way.",
//     avatar: "RP",
//     color: "#E65100",
//     image: parent4,
//   },
  {
    name: "Shrikant Khapare",
    link: "https://www.google.com/maps/contrib/112225771967186138228/reviews?hl=en-IN",
    rating: 5,
    time: "5 months ago",
    text: "Seekers Bay is an excellent preschool that truly focuses on the overall development and well-being of every child. The teachers are wonderful — caring, patient, and deeply committed to helping kids learn and grow in a happy environment.",
    avatar: "SK",
    color: "#BF360C",
    image: parent5,
  },
  {
    name: "Vaibhava Vatsal",
    link: "https://share.google/mzEbHQs9VRLnyRq5r",
    rating: 4,
    time: "a year ago",
    text: "School is good, very nice teaching staff. Need to focus on eating habits and more on speaking in English and Kannada.",
    avatar: "VV",
    color: "#E65100",
  },
  {
    name: "Shilpa",
    link: "https://share.google/a9YG4ZqgR634mww8t",
    rating: 5,
    time: "2 years ago",
    text: "@Seekers Bay we appreciate your tireless efforts to create a safe and nurturing learning environment. Principal is very committed and successful in striking an appropriate balance between Academic and Co-Curricular activities.",
    avatar: "SH",
    color: "#F57C00",
    image: parent1,
  },
  {
    name: "Shrinath M",
    link: "https://share.google/hvHJhLRMfy59Kh2Nj",
    rating: 5,
    time: "2 years ago",
    text: "Great education and school. My daughter is very smart after joining Seekers Bay school. Very good teachers, they take care of our kids very special.",
    avatar: "SM",
    color: "#E65100",
  },
  {
    name: "Bushra Anwar",
    link: "https://share.google/FuMT35s8yxvAdHeJg",
    rating: 5,
    time: "2 years ago",
    text: "We have enrolled our 2 year old kid. Noticed a great improvement. All the staff and teachers are really doing great work. He started learning rhymes, letters, actions very quickly. He enjoys his time there very much.",
    avatar: "BA",
    color: "#BF360C",
    image: parent2,
  },
  {
    name: "Gaurav Kaushik",
    link: "https://share.google/YUh83zEU0rPBgIN0b",
    rating: 5,
    time: "2 years ago",
    text: "Good school, it is in its initial stage but has potential to grow! Very close to our apartment! Academic, playground activities everything looks good! Kids are enjoying!",
    avatar: "GK",
    color: "#F57C00",
  },
  {
    name: "Amit Sau",
    link: "https://share.google/eKizwbFGkd0P8HpNy",
    rating: 5,
    time: "a year ago",
    text: "My son Aayan currently studying in nursery. I am very happy with his performance. All teachers are very cooperative. I am looking forward to continue in next year as well.",
    avatar: "AS",
    color: "#E65100",
  },
  {
    name: "p.lalitha 333",
    link: "https://share.google/NqvxXhntW5aqwhW0Q",
    rating: 5,
    time: "a year ago",
    text: "Most satisfied with Seekers Bay preschool. I have seen drastic changes in my kid in perspective of many things — can see betterment in my child. Overall review is well satisfied and most recommended.",
    avatar: "PL",
    color: "#BF360C",
  },
  {
    name: "Ashish Pathak",
    link: "https://share.google/nfcHHABIV2Yh5g8M0",
    rating: 5,
    time: "2 years ago",
    text: "We are sending our baby to daycare here and she loves the time she spends here. She has been able to learn to speak more words, eat on her own, and make friends easily. We're very happy with the results.",
    avatar: "AP",
    color: "#F57C00",
  },
  {
    name: "Akalya Perumalsamy",
    link: "https://share.google/UBdJUFkC3PH5S65jt",
    rating: 5,
    time: "a year ago",
    text: "In Rayasandra, Seekersbay is the only Pre-school which is having a big playground. Teachers are highly qualified, very friendly, caring so that our daughter loves to go to school happily.",
    avatar: "AK",
    color: "#E65100",
  },
  {
    name: "Chandan Sah",
    link: "https://share.google/e2DbP2nPT5VT65dW0",
    rating: 5,
    time: "a year ago",
    text: "We are highly satisfied with the Day care. Good environment for even small kids. Attendants are caring and even owner is also very polite and flexible. My 1.5 years kid also enjoying here and improving.",
    avatar: "CS",
    color: "#BF360C",
  },
  {
    name: "Asokan B",
    link: "https://share.google/xIZSUV4VpOtKqhgfq",
    rating: 5,
    time: "7 months ago",
    text: "Overall we had a good experience in curriculum, positive learning environment, and opportunities for extracurricular activities.",
    avatar: "AB",
    color: "#F57C00",
  },
  {
    name: "Niyati Kumar",
    link: "https://share.google/ssipXYmNXDJkJof54",
    rating: 5,
    time: "2 years ago",
    text: "After a 2-month search for a daycare that checks all our boxes, we found Seeker's Bay! The Montessori curriculum, staff behavior, the facility itself, and the adult to kid ratio are the biggest positives.",
    avatar: "NK",
    color: "#E65100",
  },
  {
    name: "Manoj Marvin",
    link: "https://share.google/AlqKkgoMGhcsiLbBb",
    rating: 5,
    time: "2 years ago",
    text: "The preschool offers a warm and nurturing environment that clearly supports early learning and creativity. The teachers are exceptional, demonstrating genuine care and dedication towards each child's growth and happiness.",
    avatar: "MM",
    color: "#BF360C",
  },
  {
    name: "Komal Kushwaha",
    link: "https://share.google/me6TGcC1XXxvg7x04",
    rating: 5,
    time: "a year ago",
    text: "Seekers Bay preschool is a good start for our little girl. She loves going to school and have grown progressively now. Teachers and staff dedication is commendable. Safety wise also it is good for kids.",
    avatar: "KK",
    color: "#F57C00",
  },
  {
    name: "Prema Manivannan",
    link: "https://share.google/VygwaxymrSD5bYJHX",
    rating: 5,
    time: "2 years ago",
    text: "One of the best preschool in this area. The staff's are well experienced and friendly. Extremely happy that it's our twin toddler's first school and we always cherish it.",
    avatar: "PM",
    color: "#E65100",
  },
  {
    name: "Madhusmita Kalita Pathak",
    link: "https://share.google/56NzLEibrCklgMGCr",
    rating: 4,
    time: "2 years ago",
    text: "Overall a good pre school — excellent, experienced humble teachers, great learning methods. Our kids are improving their activities, skills, thoughts day by day.",
    avatar: "MK",
    color: "#BF360C",
  },
  {
    name: "chandani kumari",
    link: "https://share.google/t6f7fs9z5OyfZE0FK",
    rating: 5,
    time: "5 months ago",
    text: "Environment, staffs, location, road conditions, etc, everything is good here. Would strongly recommend this pre-school to others.",
    avatar: "CK",
    color: "#F57C00",
  },
  {
    name: "nithin joseph",
    link: "https://share.google/K7X64tcTWtuPXXLpq",
    rating: 5,
    time: "a year ago",
    text: "Finally I found a good preschool for my child. The first thing which impressed me is the big play ground, which nowadays most of the preschools don't have an outdoor playground.",
    avatar: "NJ",
    color: "#E65100",
  },
  {
    name: "Shruti Kashyap",
    link: "https://share.google/kiYZbqxSVWXwhMdwZ",
    rating: 5,
    time: "a year ago",
    text: "School is very good. They are focusing on each and every child to support continuous growth. They are conducting different activities to make things learn to kids. My daughter is enjoying at school.",
    avatar: "SK",
    color: "#BF360C",
  },
  {
    name: "bijay singh",
    link: "https://share.google/2HpF1UkWgzxQcFhW1",
    rating: 5,
    time: "3 months ago",
    text: "I love this school. My kid goes here. They have a great atmosphere and ambience. The staff is very good and supportive.",
    avatar: "BS",
    color: "#F57C00",
  },
  {
    name: "Yaswanth Reddy",
    link: "https://share.google/MwiQHNZEzgXHSBn7Y",
    rating: 5,
    time: "7 months ago",
    text: "Good school, they understand child capabilities and teach accordingly. They balance both academic and extracurricular activities. School has good space for kids to play.",
    avatar: "YR",
    color: "#E65100",
  },
  {
    name: "Mangala Naik",
    link: "https://share.google/VDYBMMIbtxeaqtG5H",
    rating: 5,
    time: "7 months ago",
    text: "Wonderful preschool for the kids. Very happy with the way they teach kids. More practical way they try to explain to the kids. Specially the visit to fruit market, sports day activities all were wonderful.",
    avatar: "MN",
    color: "#BF360C",
    image: parent3,
  },
];

// ⚠️ REPLACE THIS with your actual YouTube video ID
const videoReviews = [
  {
    id: "MBzNiAp_LCU",
    title: "Seekers Bay Preschool Review 1",
    subtitle: "Parent Video Testimonial",
  },
  {
    id: "3ll43olN6jU",
    title: "Seekers Bay Preschool Review 2",
    subtitle: "Parent Video Testimonial",
  },
  {
    id: "v0UjqaD4Uag",
    title: "Seekers Bay Preschool Review 3",
    subtitle: "Parent Video Testimonial",
  },
  {
    id: "pf-kEV6UiqI",
    title: "Seekers Bay Preschool Review 4",
    subtitle: "Parent Video Testimonial",
  },
];

const StarRating = ({ rating }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((star) => (
      <svg
        key={star}
        className={`w-4 h-4 ${star <= rating ? "text-orange-400" : "text-gray-600"}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ))}
  </div>
);

const GoogleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

const ReviewCard = ({ review }) => (
  <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5 flex flex-col gap-3 hover:border-orange-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-orange-900/20 group">
    {/* Header */}
    <div className="flex items-start gap-3">
      <a
        href={review.link}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-shrink-0"
      >
        {review.image ? (
          <img
            src={review.image}
            alt={review.name}
            className="w-11 h-11 rounded-full object-cover shadow-md"
          />
        ) : (
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md"
            style={{ backgroundColor: review.color }}
          >
            {review.avatar}
          </div>
        )}
      </a>
      <div className="flex-1 min-w-0">
        <a
          href={review.link}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-white text-sm hover:text-orange-400 transition-colors truncate block"
        >
          {review.name}
        </a>
        <div className="flex items-center gap-2 mt-0.5">
          <StarRating rating={review.rating} />
          <span className="text-zinc-500 text-xs">{review.time}</span>
        </div>
      </div>
      <GoogleIcon />
    </div>

    {/* Review text */}
    <p className="text-zinc-300 text-sm leading-relaxed line-clamp-4">
      {review.text}
    </p>

    {/* Footer */}
    <div className="pt-1 border-t border-zinc-800">
      <a
        href={review.link}
        target="_blank"
        rel="noopener noreferrer"
        className="text-orange-400 text-xs font-medium hover:text-orange-300 transition-colors flex items-center gap-1"
      >
        View on Google
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
        </svg>
      </a>
    </div>
  </div>
);

export default function SeekersReviews() {
  const [showAll, setShowAll] = useState(false);
  const visibleReviews = showAll ? reviews : reviews.slice(0, 8);

  const totalRating = (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <div className="min-h-screen bg-[rgb(122,49,125)] text-white">
      {/* Hero */}
      <div className="relative overflow-hidden  border-b border-zinc-800">
        <div
          className="absolute inset-0 opacity-10"
        //   style={{
        //     backgroundImage:
        //       "radial-gradient(circle at 20% 50%, #E65100 0%, transparent 50%), radial-gradient(circle at 80% 20%, #F57C00 0%, transparent 40%)",
        //   }}
        />
        <div className="relative max-w-6xl mx-auto px-4 py-14 text-center">
          <div className="inline-flex items-center gap-2 bg-orange-500/10 border border-orange-500/30 rounded-full px-4 py-1.5 mb-5">
            <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" />
            <span className="text-orange-400 text-xs font-semibold tracking-wider uppercase">
              Parent Reviews
            </span>
          </div>
          <h1 className="text-3xl sm:text-5xl font-black text-white mb-3 leading-tight">
            What Parents Say About<br />
            <span className="text-transparent bg-clip-text" style={{ backgroundImage: "linear-gradient(90deg, #000000, #000000)" }}>
              Seekers Bay
            </span>
          </h1>
          <p className="text-zinc-400 text-base sm:text-lg max-w-xl mx-auto mb-8">
            Real experiences from families at Seekers Bay Pre-School, Rayasandra Gattahalli
          </p>

          {/* Stats */}
          <div className="flex flex-wrap justify-center gap-6 sm:gap-12">
            <div className="text-center">
              <div className="text-4xl font-black text-gray-900">{totalRating}</div>
              <div className="flex justify-center mt-1"><StarRating rating={5} /></div>
              <div className="text-gray-100 text-xs mt-1">Average Rating</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-black text-gray-900">255+</div>
              <div className="text-gray-100 text-xs mt-1">Google Reviews</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-black text-gray-900">5★</div>
              <div className="text-gray-100 text-xs mt-1">Most Common Rating</div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-12">

        {/* YouTube Video Section */}
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-7 rounded-full bg-orange-500" />
            <h2 className="text-xl sm:text-2xl font-bold text-white">Video Reviews</h2>
            <div className="flex-1 h-px bg-zinc-800 ml-2" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {videoReviews.map((video) => (
              <div
                key={video.title}
                className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden shadow-2xl shadow-orange-900/10"
              >
                <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src={`https://www.youtube.com/embed/${video.id}?rel=0&modestbranding=1`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="p-4 border-t border-zinc-800 flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.28 8.28 0 004.84 1.56V6.82a4.85 4.85 0 01-1.07-.13z"/>
                    </svg>
                  </div>
                  <div>
                    <p className="text-white text-sm font-semibold">{video.title}</p>
                    <p className="text-zinc-500 text-xs">{video.subtitle}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-7 rounded-full bg-orange-500" />
            <h2 className="text-xl sm:text-2xl font-bold text-white">Google Reviews</h2>
            <div className="flex-1 h-px bg-zinc-800 ml-2" />
            <div className="flex items-center gap-1.5 bg-zinc-900 border border-zinc-800 rounded-full px-3 py-1.5">
              <GoogleIcon />
              <span className="text-zinc-400 text-xs font-medium">Verified</span>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {visibleReviews.map((review, index) => (
              <ReviewCard key={index} review={review} />
            ))}
          </div>
        </div>

        {/* Show More Button */}
        {reviews.length > 8 && (
          <div className="text-center mb-12">
            <button
              onClick={() => setShowAll(!showAll)}
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-semibold text-sm transition-all duration-300"
              style={{
                background: showAll
                  ? "transparent"
                  : "linear-gradient(135deg, #E65100, #F57C00)",
                border: showAll ? "1px solid #E65100" : "none",
                color: "white",
              }}
            >
              {showAll ? "Show Less" : `View All ${reviews.length} Reviews`}
              <svg
                className={`w-4 h-4 transition-transform ${showAll ? "rotate-180" : ""}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>
        )}

        {/* CTA Banner */}
        <div
          className="rounded-2xl p-8 text-center relative overflow-hidden"
          style={{
            background: "linear-gradient(135deg, #1a0a00 0%, #2d1000 50%, #1a0a00 100%)",
            border: "1px solid rgba(230, 81, 0, 0.3)",
          }}
        >
          <div
            className="absolute inset-0 opacity-20"
            style={{
              backgroundImage: "radial-gradient(circle at 50% 50%, #F57C00 0%, transparent 60%)",
            }}
          />
          <div className="relative">
            <div className="text-4xl mb-3">⭐</div>
            <h3 className="text-2xl font-black text-white mb-2">
              Join the Seekers Bay Family
            </h3>
            <p className="text-zinc-400 text-sm mb-6 max-w-sm mx-auto">
              See why hundreds of parents trust us with their child's early education journey.
            </p>
            <a
              href="https://share.google/r1FBPVl9hUVEeCq8N"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full font-bold text-sm text-white transition-all duration-300 hover:opacity-90 hover:scale-105"
              style={{ background: "linear-gradient(135deg, #E65100, #F57C00)" }}
            >
              <GoogleIcon />
              See All Reviews on Google
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
